import { Button, Tooltip, Progress } from "antd";
import { formatDate } from "../../../utility/formatDate";
import { EyeOutlined } from "@ant-design/icons";

export const getColumns = (navigate) => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    width: 200,
  },
  {
    title: "Level",
    dataIndex: "courseLevel",
    key: "courseLevel",
    width: 100,
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: "left",
    width: 150,
    ellipsis: true,
    render: (text) => (
      <Tooltip title={text} placement="topLeft" mouseEnterDelay={0.3}>
        <div className="max-w-[130px] truncate cursor-pointer">
          {text || "N/A"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Assigned By",
    dataIndex: "assignedBy",
    key: "assignedBy",
    width: 140,
  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    key: "deadline",
    width: 130,
    render: (date) => formatDate(date, "DD MMM YYYY"),
  },
  {
    title: "Completion %",
    dataIndex: "completionPercentage",
    key: "completionPercentage",
    width: 160,
    render: (progress = 0) => (
      <Progress
        percent={Number((progress || 0).toFixed(2))}
        size="small"
        strokeColor={progress >= 100 ? "#088A15" : "#1777FF"}
        showInfo={true}
        format={(percent) => (
          <span className="font-['Inter'] font-medium text-xs">
            {percent}%
          </span>
        )}
      />
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 110,
  },
  {
    title: "Action",
    key: "action",
    width: 80,
    align: "center",
    render: (_, record) => (
      <Tooltip title="View">
        <Button
          type="text"
          className="view-action-btn"
          icon={<EyeOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/my-courses/course-content-user/${record.courseId}`);
          }}
        />
      </Tooltip>
    ),
  },
];